import { FC } from 'react';
import styles from './Advantages.module.scss';
import HTMLReactParser from 'html-react-parser';

export interface IAdvantagesProps {
  list: {
    title: string;
  }[];
}

const Advantages: FC<IAdvantagesProps> = ({ list }) => {
  return (
    <div className={styles.Advantages}>
      <div className={styles.holder}>
        {list.map((item, index) => (
          <div key={index} className={styles.item}>
            <h3 className={styles.title}>{HTMLReactParser(item.title)}</h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Advantages;
